import { render, staticRenderFns } from "./EllipsisTooltip.vue?vue&type=template&id=41f654e2&scoped=true&"
import script from "./EllipsisTooltip.vue?vue&type=script&lang=js&"
export * from "./EllipsisTooltip.vue?vue&type=script&lang=js&"
import style0 from "./EllipsisTooltip.vue?vue&type=style&index=0&id=41f654e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f654e2",
  null
  
)

export default component.exports